import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper
} from "@mui/material";

export default function ItemInfo({ itemList, tab, setTab }) {
  const [filter, setFilter] = useState("All");
  const [enhOnly, setEnhOnly] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [items, setItems] = useState([]);

  useEffect(() => {
    let filtered = itemList;  

    if (enhOnly) {
      // Only right‑handed weapons are grouped with enhancement
      const baseWeapons = filtered.filter(
        (it) => it.type === "Right-handed Weapon" && it.enchanced
      );
      // Build a list with enhanced versions inserted under each base
      filtered = [];
      baseWeapons.forEach(element => {
        filtered.push(element);
        filtered.push(itemList.find(it => it.name === "Enchanced " + element.name));
      });
      filtered.push(itemList.find(it => it.id === "I025"));
      filtered.push(itemList.find(it => it.id === "I070"));
      setFilter("Right-handed Weapon");
    } else {
      // Normal filters when not in enhanced mode
      if (filter !== "All") {
        filtered = filtered.filter((it) =>
          it.type.toLowerCase().includes(filter.toLowerCase())
        );
      }
    }

    // Search filter applies after others
    if (searchText.trim()) {
      const text = searchText.toLowerCase();
      filtered = filtered.filter(
        (it) =>
          it.name.toLowerCase().includes(text) ||
          it.description.toLowerCase().includes(text)
      );
    }

    setItems(filtered);
  }, [itemList, filter, enhOnly, searchText]);

  const handleFind = (item) => {
    // Change URL without reloading
    window.history.pushState({}, "", `/${item.id}`);
    
    // Dispatch event to notify AppRoot
    window.dispatchEvent(new CustomEvent("findItem", { detail: item.id }));
    setTab(0);
  };

  return (
    <Box sx={{ p: 4, maxWidth: 1000, mx: "auto" }}>
      <Typography variant="h3" sx={{ mb: 4, color: "#1976d2" }}>
        Item Information
      </Typography>
      <Box sx={{ display: "flex", gap: 2, alignItems: "center", mb: 3, flexWrap: "wrap" }}>
        <FormControl sx={{ minWidth: 200 }}>
          <InputLabel>Type</InputLabel>
          <Select
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
            disabled={enhOnly}
            label="Type"
          >
            <MenuItem value="All">All</MenuItem>
            <MenuItem value="None">None</MenuItem>
            <MenuItem value="Hat">Hat</MenuItem>
            <MenuItem value="Right-handed Weapon">Right-handed Weapon</MenuItem>
            <MenuItem value="Left Hand">Left Hand</MenuItem>
            <MenuItem value="Spell">Spell</MenuItem>
            <MenuItem value="Summmon">Summon</MenuItem>
            <MenuItem value="Misc">Misc</MenuItem>
          </Select>
        </FormControl>

        <TextField
          label="Search..."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          sx={{ flex: 1, minWidth: 250 }}
        />

        <FormControl sx={{ display: "flex", alignItems: "center" }}>
          <Typography sx={{ mr: 1 }}>Enhanced Only</Typography>
          <Switch
            checked={enhOnly}
            onChange={(e) => setEnhOnly(e.target.checked)}
          />
        </FormControl>

        
      </Box>

      <TableContainer component={Paper}>
        <Table>
          <TableHead sx={{ backgroundColor: "#005b9f" }}>
            <TableRow>
              <TableCell sx={{ color: "white" }}>Name</TableCell>
              <TableCell sx={{ color: "white" }}>Type</TableCell>
              <TableCell sx={{ color: "white" }}>Description</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map((it) => (
              <TableRow key={it.id}>
                <TableCell>{it.name}</TableCell>
                <TableCell>{it.type}</TableCell>
                <TableCell>{it.description} <button onClick={() => handleFind(it)}>Find</button></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
